<fs-base-address-editor
    [translations]="(addressTranslationsList$ | async)"
    [addressList]="(getAddresses$() | async) || []"
    (onConfirmAddress)="confirmAddressClick($event)"
    (onSetDefaultAddress)="onExistingAddressSelect($event)"
    (onDeleteAddress)="onDeleteAddress($event)"
    (onBrowserBlockedError)="onBrowserBlockedError()"
    (onBrowserNotSupportedError)="onBrowserNotSupportedError()"
    (onBackgroundPress)="onBackgroundPress()"
></fs-base-address-editor>